import { useQuery } from '@tanstack/react-query';
import { apiGetRiskCategories } from '../api/risks.api';

export function useRiskCategories(projectId: string, enabled = true) {
    return useQuery({
        queryKey: ['riskCategories', projectId],
        queryFn: () => apiGetRiskCategories(projectId),
        enabled,
    });
}
